(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var layers = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
  if (!layers.length) return;
  var ticking = false;
  
  function update() {
    var vh = window.innerHeight;
    layers.forEach(function (el) {
      var box = el.parentElement.getBoundingClientRect();
      if (box.bottom < 0 || box.top > vh) return;
      var offsetFromCentre = box.top + box.height / 2 - vh / 2;
      var shift = -offsetFromCentre * parseFloat(el.getAttribute('data-parallax'));
      var scale = el.getAttribute('data-parallax-scale');
      el.style.transform = 'translate3d(0,' + shift.toFixed(1) + 'px,0)' + (scale ? ' scale(' + scale + ')' : '');
    });
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();
})();